<div [formGroup]="form" >
    <div class="form-group row cv-field-container">
        <label for="cvField.key" class="col-sm-5 col-form-label">{{cvField.label}}:</label>
        <div class="col-sm-7">
            <input [id]="cvField.key" type="text" class="form-control" pattern="{{cvField.pattern}}"
                placeholder="{{cvField.placeholder}}" [formControlName]="cvField.key" />
        </div>

        <!-- <div class="error-txt-msg mb-2" *ngIf="form.controls[cvField.key].hasError('required')" style="color: red;">
            Required field.
          </div> -->

          <!-- <div class="col-sm-5 alert alert-danger" *ngIf="form.controls[cvField.key].hasError('pattern')">
            Incorrect format.
          </div> -->


          <div class="error-txt-msg mb-2" *ngIf="form.controls[cvField.key].hasError('pattern')" style="color: red;">
            {{cvField.invalidFormatMsg}}
          </div>

    </div>

</div>
